<template>
  <Dialog
    v-model:visible="visibleModal"
    v-bind="props"
    :style="{ width: !!width ? width : '50rem' }"
    :pt="{
      root: {
        class: mobileFullScreen
          ? 'max-sm:!w-full max-sm:!h-full max-sm:!max-h-full max-sm:!m-0 max-sm:!rounded-none max-sm:!top-0 max-sm:!left-0'
          : 'max-sm:!w-[calc(100%-2rem)] max-sm:!mx-4',
      },
      content: {
        class: mobileFullScreen ? 'max-sm:grow max-sm:overflow-y-auto' : '',
      },
      footer: { class: footerClass },
    }"
    @keyup.enter.prevent="emit('confirm-action', $event)"
    @keyup.esc="visibleModal = false"
  >
    <template #header v-if="$slots.header || header">
      <slot name="header">
        <div class="flex items-center gap-3">
          <div
            v-if="icon"
            class="p-2.5 bg-primary-500/10 dark:bg-primary-500/10 border border-primary-500/20 dark:border-primary-500/30 rounded-lg"
          >
            <Icon :icon="icon" class="min-w-5 min-h-5 text-primary-600 dark:text-primary-100" />
          </div>
          <h2 :class="headerClass">
            {{ header }}
          </h2>
        </div>
      </slot>
    </template>

    <slot />

    <template #footer>
      <section v-if="hasFooter" :class="footerClass">
        <HealthButton
          v-if="buttonLeftLabel"
          :autofocus="autofocus"
          :color="colorConfirmButton"
          :size="sizeButton"
          :label="t(buttonLeftLabel)"
          :icon="buttonLeftIcon"
          :loading="loading"
          @click.prevent="emit('confirm-action', $event)"
          @keyup.enter.stop
        />

        <HealthButton
          v-if="buttonRightLabel"
          :color="colorCancelButton"
          :size="sizeButton"
          :label="t(buttonRightLabel)"
          :icon="buttonRightIcon"
          @action="visibleModal = false"
          @keyup.enter.stop
        />
      </section>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
  import { useI18n } from "vue-i18n";
  import { Icon } from "@iconify/vue";
  import Dialog from "primevue/dialog";
  import type { DialogProps } from "@/shared/components/utils/modal/props.ts";
  import HealthButton from "@/shared/components/utils/button/HealthButton.vue";

  const { t } = useI18n();

  const emit = defineEmits(["confirm-action"]);

  const visibleModal = defineModel("visible", { default: false, type: Boolean });

  const props = withDefaults(defineProps<DialogProps>(), {
    autofocus: false,
    loading: false,
    customFooter: false,
    modal: true,
    headerClass: "text-xl font-bold text-gray-800 dark:text-gray-100",
    colorConfirmButton: "primary",
    footerClass: "flex items-center justify-center gap-x-2 gap-y-1",
    buttonLeftLabel: "confirm",
    buttonLeftIcon: "line-md:circle-to-confirm-circle-transition",
    sizeButton: "px-3 py-2",
    buttonRightLabel: "cancel",
    colorCancelButton: "red",
    buttonRightIcon: "ic:outline-cancel",
    width: null,
    hasFooter: true,
    mobileFullScreen: true,
  });
</script>
